import { Card, CardContent, Typography, Box } from '@mui/material'
import { useEffect, useState } from 'react'
import VerticalBar from '../charts/VerticalBar'

export default function VisitPlanVsRealCard({
  title = 'VISITAS: PLANEADA VS REAL',
  plan_visit = 0,
  real_visit = 0,
  max = 1000
}) {
  const compliance = plan_visit > 0 ? Math.round((real_visit / plan_visit) * 100) : 0

  const [animatedValue, setAnimatedValue] = useState(0)

  useEffect(() => {
    let current = 0
    const step = Math.max(compliance / 30, 1)

    const interval = setInterval(() => {
      current += step
      if (current >= compliance) {
        setAnimatedValue(compliance)
        clearInterval(interval)
      } else {
        setAnimatedValue(Math.round(current))
      }
    }, 20)

    return () => clearInterval(interval)
  }, [compliance])

  return (
    <Card elevation={4} sx={{ borderRadius: 2, height: 250, width: 530, border: '3px solid #E4E4E4', boxShadow: 0 }}>
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Typography fontWeight={700} sx={{ color: '#4A4F62', mt: 2 }}>
          {title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            mt: -2
          }}
        >
        <Box>
            <Typography
              sx={{
                fontSize: 64,
                fontWeight: 800,
                textAlign: 'center',
                width: 200,
              }}
            >
              {animatedValue}%
            </Typography>

            <Typography sx={{ color: '#A0A4AE', fontSize: 20, textAlign: 'center' }}>
              Cumplimiento real
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, height: 150 }}>
            <VerticalBar label="PLAN" value={plan_visit} max={max} color="#5B7DB1" delay={0} />
            <VerticalBar label="REAL" value={real_visit} max={max} color="#FF8A3D" delay={120} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
